import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { Card, CardContent, Image } from '@thd-olt-component-react/core-ui';
import styles from './store-hero-workshop.module.scss';

const cx = classNames.bind(styles);

const StoreHeroWorkshop = ({ className }) => {
  return (
    <Card className={cx(className, 'store-hero-workshop')} sharp>
      <CardContent>
        <a className={cx('store-hero-workshop__wrapper')} href="/workshops">
          <Image
            alt="DIY Workshops"
            asset="diy-workshops.svg"
            className={cx('store-hero-workshop__image')}
            height={40}
            width={40}
          />
          <div>
            <span className={cx('store-hero-workshop__text--bold')}>Attend a Free Online Workshop</span>
            <span>Home Projects for All Level of Doers</span>
          </div>
          <Image
            alt=""
            asset="next-arrow-orange.svg"
            className={cx('store-hero-workshop__arrow')}
            height="24"
            width="20"
          />
        </a>
      </CardContent>
    </Card>
  );
};

StoreHeroWorkshop.propTypes = {
  className: string
};

StoreHeroWorkshop.defaultProps = {
  className: null
};

StoreHeroWorkshop.displayName = 'StoreHeroWorkshop';

export { StoreHeroWorkshop };
